const options = document.querySelectorAll('input[type=radio]');
const sourceOption = document.querySelectorAll('.sourceOption');
import { fetchButton, gatherEmUp, postRequestFilter } from "..";

let customSearchInputValue = '';
let fromDate = '';
let toDate = '';
let paginationCounter = 0;
export const inputEventListeners = () => {
    const increasePagination = () => {
        paginationCounter = paginationCounter + 25;
        console.log(paginationCounter),
            gatherEmUp();
    }
    let paginationButtons = document.getElementsByClassName('paginationButton');
    for (let i = 0; i < paginationButtons.length; i++) {
        paginationButtons[i].addEventListener('click', increasePagination, false);
    }
    const fromDateInputHandler = (e) => {
        fromDate = e.target.value;
        if (e.code === 'Enter') {
            fetchButton.click();
        }
    }
    const toDateInputHandler = (e) => {
        toDate = e.target.value;
        if (e.code === 'Enter') {
            fetchButton.click();
        }
    }
    datePickerFrom.addEventListener('change', fromDateInputHandler)
    datePickerFrom.addEventListener('keydown', (e) => {
        if (e.code === 'Enter') {
            fetchButton.click();
        }
    })
    datePickerTo.addEventListener('change', toDateInputHandler)
    datePickerTo.addEventListener('keydown', (e) => {
        if (e.code === 'Enter') {
            fetchButton.click();
        }
    })

    const keywordInputHandler = (e) => {
        customSearchInputValue = e.target.value;
    }
    keywordInput.addEventListener('input', keywordInputHandler)
    keywordInput.addEventListener('keydown', (e) => {
        if (e.code === 'Enter') {
            fetchButton.click();
        }
    })

    optionsButton.addEventListener('click', () => {
        document.querySelector('.searchOptionsContainer').classList.toggle('hide');
    })
    fetchButton.addEventListener('click', async () => {
        fetchButton.disabled = true;
        leftColumn.replaceChildren();
        centerColumn.replaceChildren();
        rightColumn.replaceChildren();
        let paginationButton = document.createElement("button");
        paginationButton.classList.add('paginationButton');
        paginationButton.innerHTML = ("More...")
        leftColumn.insertAdjacentElement("afterBegin", paginationButton.cloneNode(true));
        centerColumn.insertAdjacentElement("afterBegin", paginationButton.cloneNode(true));
        rightColumn.insertAdjacentElement("afterBegin", paginationButton.cloneNode(true));
        for (let i = 0; i < paginationButtons.length; i++) {
            paginationButtons[i].addEventListener('click', increasePagination, false);
        }
        await postRequestFilter();
        gatherEmUp();
    })
    sourceOption.forEach(sourceOption => {
        sourceOption.addEventListener('change', (sourceOption) => {
            let targetId = sourceOption.target.id;
            let lsItem = targetId;
            switch (targetId) {
                case 'alternet':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/false/) ? localStorage.setItem('alternet', "true") : localStorage.setItem('alternet', "false");
                    break;

                case 'hackerNews':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/false/) ? localStorage.setItem('hackerNews', "true") : localStorage.setItem('hackerNews', "false");
                    break;
                case 'techCrunch':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('techCrunch', "false") : localStorage.setItem('techCrunch', "true");
                    break;
                case 'cnn':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('cnn', "false") : localStorage.setItem('cnn', "true");
                    break;
                case 'wired':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('wired', "false") : localStorage.setItem('wired', "true");
                    break;
                case 'guardian':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('guardian', "false") : localStorage.setItem('guardian', "true");
                    break;
                case 'independent':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('independent', "false") : localStorage.setItem('independent', "true");
                    break;
                case 'nyTimes':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('nyTimes', "false") : localStorage.setItem('nyTimes', "true");
                    break;
                case 'seekingAlpha':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('seekingAlpha', "false") : localStorage.setItem('seekingAlpha', "true");
                    break;
                case 'nbc':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('nbc', "false") : localStorage.setItem('nbc', "true");
                    break;

                case 'politico':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('politico', "false") : localStorage.setItem('politico', "true");
                    break;
                case 'forbes':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('forbes', "false") : localStorage.setItem('forbes', "true");
                    break;

                case 'time':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('time', "false") : localStorage.setItem('time', "true");
                    break;

                case 'bbc':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('bbc', "false") : localStorage.setItem('bbc', "true");
                    break;

                case 'marketWatch':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('marketWatch', "false") : localStorage.setItem('marketWatch', "true");
                    break;

                case 'dailyMail':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('dailyMail', "false") : localStorage.setItem('dailyMail', "true");
                    break;

                case 'foxNews':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('foxNews', "false") : localStorage.setItem('foxNews', "true");
                    break;

                case 'nationalReview':
                    lsItem = localStorage.getItem(targetId)
                    lsItem.match(/true/) ? localStorage.setItem('nationalReview', "false") : localStorage.setItem('nationalReview', "true");
                    break;


                default:
                    break;

            }
        })
    })

    options.forEach(option => {
        option.addEventListener('change', (event) => {
            let targetEl = event.target;
            let targetId = event.target.id;
            switch (targetId) {
                case 'alternetL':
                    localStorage.setItem('alternetBias', 'left');
                    break;
                case 'alternetC':
                    localStorage.setItem('alternetBias', 'center');
                    break;
                case 'alternetR':
                    localStorage.setItem('alternetBias', 'right');
                    break;

                case 'hackerNewsL':
                    localStorage.setItem('hackerNewsBias', 'left');
                    break;
                case 'hackerNewsC':
                    localStorage.setItem('hackerNewsBias', 'center');
                    break;
                case 'hackerNewsR':
                    localStorage.setItem('hackerNewsBias', 'right');
                    break;
                case 'techCrunchL':
                    localStorage.setItem('techCrunchBias', 'left');
                    break;
                case 'techCrunchC':
                    localStorage.setItem('techCrunchBias', 'center');
                    break;
                case 'techCrunchR':
                    localStorage.setItem('techCrunchBias', 'right');
                    break;
                case 'cnnL':
                    localStorage.setItem('cnnBias', 'left');
                    break;
                case 'cnnC':
                    localStorage.setItem('cnnBias', 'center');
                    break;
                case 'cnnR':
                    localStorage.setItem('cnnBias', 'right');
                    break;
                case 'wiredL':
                    localStorage.setItem('wiredBias', 'left');
                    break;
                case 'wiredC':
                    localStorage.setItem('wiredBias', 'center');
                    break;
                case 'wiredR':
                    localStorage.setItem('wiredBias', 'right');
                    break;

                case 'guardianL':
                    localStorage.setItem('guardianBias', 'left');
                    break;
                case 'guardianC':
                    localStorage.setItem('guardianBias', 'center');
                    break;
                case 'guardianR':
                    localStorage.setItem('guardianBias', 'right');
                    break;
                case 'seekingAlphaL':
                    localStorage.setItem('seekingAlphaBias', 'left');
                    break;
                case 'seekingAlphaC':
                    localStorage.setItem('seekingAlphaBias', 'center');
                    break;
                case 'seekingAlphaR':
                    localStorage.setItem('seekingAlphaBias', 'right');
                    break;
                case 'independentL':
                    localStorage.setItem('independentBias', 'left');
                    break;
                case 'independentC':
                    localStorage.setItem('independentBias', 'center');
                    break;
                case 'independentR':
                    localStorage.setItem('independentBias', 'right');
                    break;
                case 'nyTimesL':
                    localStorage.setItem('nyTimesBias', 'left');
                    break;
                case 'nyTimesC':
                    localStorage.setItem('nyTimesBias', 'center');
                    break;
                case 'nyTimesR':
                    localStorage.setItem('nyTimesBias', 'right');
                    break;
                case 'nbcL':
                    localStorage.setItem('nbcBias', 'left');
                    break;
                case 'nbcC':
                    localStorage.setItem('nbcBias', 'center');
                    break;
                case 'nbcR':
                    localStorage.setItem('nbcBias', 'right');
                    break;

                case 'nbcL':
                    localStorage.setItem('nbcBias', 'left');
                    break;
                case 'nbcC':
                    localStorage.setItem('nbcBias', 'center');
                    break;
                case 'nbcR':
                    localStorage.setItem('nbcBias', 'right');
                    break;

                case 'politicoL':
                    localStorage.setItem('politicoBias', 'left');
                    break;
                case 'politicoC':
                    localStorage.setItem('politicoBias', 'center');
                    break;
                case 'politicoR':
                    localStorage.setItem('politicoBias', 'right');
                    break;
                case 'forbesL':
                    localStorage.setItem('forbesBias', 'left');
                    break;
                case 'forbesC':
                    localStorage.setItem('forbesBias', 'center');
                    break;
                case 'forbesR':
                    localStorage.setItem('forbesBias', 'right');
                    break;
                case 'timeL':
                    localStorage.setItem('timeBias', 'left');
                    break;
                case 'timeC':
                    localStorage.setItem('timeBias', 'center');
                    break;
                case 'timeR':
                    localStorage.setItem('timeBias', 'right');
                    break;

                case 'bbcL':
                    localStorage.setItem('bbcBias', 'left');
                    break;
                case 'bbcC':
                    localStorage.setItem('bbcBias', 'center');
                    break;
                case 'bbcR':
                    localStorage.setItem('bbcBias', 'right');
                    break;

                case 'marketWatchL':
                    localStorage.setItem('marketWatchBias', 'left');
                    break;
                case 'marketWatchC':
                    localStorage.setItem('marketWatchBias', 'center');
                    break;
                case 'marketWatchR':
                    localStorage.setItem('marketWatchBias', 'right');
                    break;

                case 'dailyMailL':
                    localStorage.setItem('dailyMailBias', 'left');
                    break;
                case 'dailyMailC':
                    localStorage.setItem('dailyMailBias', 'center');
                    break;
                case 'dailyMailR':
                    localStorage.setItem('dailyMailBias', 'right');
                    break;

                case 'foxNewsL':
                    localStorage.setItem('foxNewsBias', 'left');
                    break;
                case 'foxNewsC':
                    localStorage.setItem('foxNewsBias', 'center');
                    break;
                case 'foxNewsR':
                    localStorage.setItem('foxNewsBias', 'right');
                    break;

                case 'nationalReviewL':
                    localStorage.setItem('nationalReviewBias', 'left');
                    break;
                case 'nationalReviewC':
                    localStorage.setItem('nationalReviewBias', 'center');
                    break;
                case 'nationalReviewR':
                    localStorage.setItem('nationalReviewBias', 'right');
                    break;
            }
        })
    })
}

export {
    customSearchInputValue,
    fromDate,
    toDate,
    paginationCounter
} 